/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React from 'react';
import { Empty, Table } from 'antd';
import { useVT } from 'virtualizedtableforantd4';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const scrollConfig = {
  y: 345,
  x: true,
};

interface ISmartTable {
  lastId: any;
  dataSource: any;
  debug: boolean;
  infinity: boolean;
  loadingIndicator: boolean;
  onFetch: () => void;
  scroll: any;
  hasMore?: boolean;
  isSearched?: boolean;
}

const SmartTable: React.FC<ISmartTable> = ({
  debug = false,
  infinity = false,
  dataSource = [],
  scroll = scrollConfig,
  onFetch = () => null,
  lastId,
  hasMore,
  isSearched,
  ...props
}) => {
  if (!infinity) {
    return <Table dataSource={dataSource} {...props} id="table-body-append" />;
  }

  const [vt] = useVT(
    () => ({
      onScroll: ({ isEnd }: never) => {
        if (isEnd) {
          if (hasMore && onFetch) {
            console.log('loadDataByChunk');
            onFetch();
          }
        }
      },
      scroll: { y: scrollConfig.y },
      debug,
    }),
    [lastId, dataSource],
  );

  const selectedListFilter = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.appliedFilters);
  const selectedContactFilter = useSelector((state: RootState) => state.contactsFilters.globalContactsFilters.appliedFilters);
  const listFilterApplied = selectedListFilter.designation.length > 0 || selectedListFilter.status.length > 0
    || selectedListFilter.organization.length > 0 || selectedListFilter.personalityType.length > 0;
  const contactFilterApplied = selectedContactFilter.designation.length > 0 || selectedContactFilter.status.length > 0
    || selectedContactFilter.organization.length > 0 || selectedContactFilter.personalityType.length > 0;

  return (
    <Table id="table-body-append" dataSource={dataSource} scroll={scroll} components={vt} pagination={false} locale={{ emptyText: <Empty description={`${isSearched || listFilterApplied || contactFilterApplied ? 'No contact(s) found against your search' : 'Your contact(s) will show up here once you will import a list or create a new contact.'}`} image={Empty.PRESENTED_IMAGE_SIMPLE} /> }} {...props} />
  );
};

export default SmartTable;
